import { Sort } from '@angular/material/sort';

export const TESTS_SORTABLE_COLUMNS = [
	'status',
	'serialnumber',
	'start',
	'latest',
	'runs',
	'modemStatus',
];

export const TESTS_DEFAULT_SORT: Sort = { active: 'latest', direction: 'desc' };
